import { withTranslations } from 'src/i18n/static-generation';
import { PageMetas } from 'src/types/meta';
import CookiePolicyView from 'src/views/CookiePolicy';
export const getStaticProps = withTranslations<PageMetas>(() => ({
  props: {
    noindex: true,
    isIncidental: true
  }
}));
export default CookiePolicyView;